<template>
  <!-- <van-nav-bar :title="$t($route.meta.title as string)" :left-arrow="!tabbarVisible" @click-left="goBack" /> -->
  <div class="main-page maxWidthPx" :class="{ tabbar1: tabbarVisible, border: showBorder }">
    <!-- 缓存页面 -->
    <RouterView v-slot="{ Component, route }" v-if="$route.meta.keepAlive">
      <keep-alive>
        <component :is="Component" />
      </keep-alive>
    </RouterView>
    <!-- 非缓存页面 -->
    <RouterView v-slot="{ Component, route }" v-else>
      <component :is="Component" />
    </RouterView>
  </div>
  <!-- 底部导航栏 -->
  <van-tabbar v-if="tabbarVisible" v-model="activeTab" inactive-color="#000" active-color="#2969FF" @change="tabSwitch"
    class="tabbar">
    <van-tabbar-item to="/home">
      <span>{{ t('tabbar.a1') }}</span>
      <template #icon="props">
        <img v-if="props.active" class="imgTab" src="@/assets/images/tab11.svg" />
        <img v-else class="imgTab" src="@/assets/images/tab1.svg" />
      </template>
    </van-tabbar-item>
    <van-tabbar-item to="/transaction">
      <span>{{ t('tabbar.a2') }}</span>
      <template #icon="props">
        <img v-if="props.active" class="imgTab" src="@/assets/images/tab22.svg" />
        <img v-else class="imgTab" src="@/assets/images/tab2.svg" />
      </template>
    </van-tabbar-item>
    <van-tabbar-item to="/market">
      <span>{{ t('tabbar.a3') }}</span>
      <template #icon="props">
        <img v-if="props.active" class="imgTab" src="@/assets/images/tab33.svg" />
        <img v-else class="imgTab" src="@/assets/images/tab3.svg" />
      </template>
    </van-tabbar-item>
    <van-tabbar-item to="/asset">
      <span>{{ t('tabbar.a4') }}</span>
      <template #icon="props">
        <img v-if="props.active" class="imgTab" src="@/assets/images/tab44.svg" />
        <img v-else class="imgTab" src="@/assets/images/tab4.svg" />
      </template>
    </van-tabbar-item>
    <van-tabbar-item to="/mine">
      <span>{{ t('tabbar.a5') }}</span>
      <template #icon="props">
        <img v-if="props.active" class="imgTab" src="@/assets/images/tab55.svg" />
        <img v-else class="imgTab" src="@/assets/images/tab5.svg" />
      </template>
    </van-tabbar-item>
  </van-tabbar>
  <!-- 语言切换 -->
  <van-popup v-model:show="show" round>
    <div class="popup">
      <div class="popup-title"> {{ t('basic.a1') }} </div>
      <div class="popup-content">
        <van-radio-group v-model="checked" @change="langChange">
          <van-radio :name="v.key" label-position="left" checked-color="#2969FF" v-for="v in langs" :key="v.key">{{
            v.name
          }}</van-radio>
          <!-- <van-radio name="es-AR" label-position="left" checked-color="#2969FF">Español</van-radio>
          <van-radio name="zh-TW" label-position="left" checked-color="#2969FF">繁体中文(香港、台湾)</van-radio> -->
        </van-radio-group>
      </div>
    </div>
  </van-popup>
  <!-- 区号选择 -->
  <van-popup v-model:show="showPicker" destroy-on-close round position="bottom">
    <van-picker :confirm-button-text="t('basic.a2')" :cancel-button-text="t('basic.a3')" :model-value="pickerValue"
      :columns="columns" @cancel="showPicker = false" @confirm="onConfirm" />
  </van-popup>
</template>

<script setup name="BasicLayoutPage">
import { langApi } from "@/api"
import { setLang, getLang } from "@/i18n"
import { showLoadingToast, closeToast } from 'vant';
import { useLoadingStore } from '@/store/loading'
import { useMainStore } from '@/store'
import { useRouter, useRoute } from 'vue-router';
import { ref, watch } from "vue"
import { useI18n } from "vue-i18n"
import { eventBus } from '@/utils/eventBus'
import { initCrmChat } from '@/plugins/crmChat';
const mainStore = useMainStore()
const loadingStore = useLoadingStore()
const { t } = useI18n()

eventBus.on("toggleLangPopup", (val) => {
  show.value = val
})
eventBus.on("toggleQhPopup", (val) => {
  showPicker.value = val
})
eventBus.on("initCrmChatFun", (val) => {
  initCrmChatFun(val)
})
eventBus.on("openService", (val) => {
  openChat(val)
})
eventBus.on("destroyService", (val) => {
  if (crm) {
    destroyService()
  }
})

const tabItem = [
  { key: 'home' },
  { key: 'transaction' },
  { key: 'market' },
  { key: 'asset' },
  { key: 'mine' },
];

const router = useRouter();
const $route = useRoute();

const activeTab = ref(0);

const tabbarVisible = ref(true);

const showBorder = ref(true);

watch(
  () => router,
  () => {
    const judgeRoute = tabItem.some((item) => item.key === router.currentRoute.value.path.replace('/', ''));
    activeTab.value = tabItem.findIndex((item) => item.key === router.currentRoute.value.path.replace('/', ''));
    tabbarVisible.value = judgeRoute;
    showBorder.value = judgeRoute;
  },
  { deep: true, immediate: true },
);

const tabSwitch = (index) => {
  // switch (index) {
  //   case 0:
  //     router.push('/home');
  //     break;
  //   case 1:
  //     router.push('/transaction');
  //     break;
  //   case 2:
  //     router.push('/market');
  //     break;
  //   case 3:
  //     router.push('/asset');
  //     break;
  //   case 4:
  //     router.push('/mine');
  //     break;
  // }
  activeTab.value = index;
};

const goBack = () => {
  router.go(-1);
};
// 语言切换
const langs = ref([{
  key: 'es-AR',
  name: "Español"
}, {
  key: 'en-US',
  name: "English"
},{
  key: 'ko-KR',
  name: "한국인"
}, {
  key: 'zh-TW',
  name: "繁体中文(香港、台湾)"
}])
const show = ref(false)
const checked = ref(getLang() || 'es-AR')
function langChange(e) {
  setLang(e)
  show.value = false
  if (!mainStore.token) {
    return
  }
  langApi({
    lang: e
  }).then(res => {
    if (res.code == 200) {

    }
  })
}

// let host = location.host
// if (host != 'www.matrix-stock.com' && host != 'matrix-stock.com') {
//   langs.value.push({
//     key: 'zh-TW',
//     name: "繁体中文(香港、台湾)"
//   })
// }
// 区号选择
const columns = [
  { text: '+1', value: '1' },
  { text: '+54', value: '54' },
  { text: '+44', value: '44' },
  { text: '+34', value: '34' },
  { text: '+82', value: '82' },
  { text: '+852', value: '852' },
  { text: '+54', value: '54' },
];
const fieldValue = ref('');
const showPicker = ref(false);
const pickerValue = ref([]);
const onConfirm = ({ selectedOptions }) => {
  showPicker.value = false;
  pickerValue.value = [selectedOptions[0].value];
  fieldValue.value = selectedOptions[0].text;
  eventBus.emit("toggleAreaCode", pickerValue.value[0])
};

// 全局loading
let loadingToast
watch(
  () => loadingStore.isLoading,
  (newVal) => {
    if (newVal) {
      // 显示 Loading
      if (!loadingToast) {
        loadingToast = showLoadingToast({
          message: t('loading.a1'),
          // forbidClick: true,
          className: "qjLoadingClass",
          overlay: true,
          overlayClass: ($route.path == '/home' || $route.path == '/transaction' || $route.path == '/market' || $route.path == '/asset' || $route.path == '/mine') ? "overlay-class" : "overlay-class2",
          duration: 0
        })
      }
    } else {
      // 隐藏 Loading
      if (loadingToast) {
        // console.log(loadingToast);

        loadingToast.close()   // 只关闭这个实例
        loadingToast = null
      }
    }
  },
  { immediate: true }
)

// 客服
// const timer = ref(null)
// const setNoRead = ref(0)
let crm = null
const service = computed(() => mainStore.service)

const initCrmChatFun = async (service) => {
  if (crm) {
    await crm.destroy()
  }
  crm = await initCrmChat(service);
}
const openChat = async (service) => {
  try {
    if (!crm) {
      await initCrmChatFun(service)
    }
    crm.getCustomeServer();  // 打开客服聊天框
  } catch (err) {
    console.error('error', err);
  }
}
const destroyService = () => {
  if (crm) {
    crm.destroy()
    crm = null
  }
}

// if (service.value && mainStore.token) { //如果登录并且有客服链接直接初始化
//   eventBus.emit("initCrmChatFun", service.value)
// }
onBeforeUnmount(() => {
  // if (timer.value) {
  //     clearInterval(timer.value)
  //     timer.value = null
  // }
  destroyService()
})
</script>
<style lang="scss">
.qjLoadingClass {
  display: none !important;
}

.overlay-class {
  background: rgba(0, 0, 0, 0) !important;
  height: calc(100% - 80px) !important;
}

.overlay-class2 {
  background: rgba(0, 0, 0, 0) !important;
}
</style>
<style scoped lang="scss">
.nut-navbar {
  margin-bottom: 0;
}

.main-page {
  box-sizing: border-box;
  // height: calc(100vh - 92px);
  // overflow-y: scroll;
  // overflow-x: hidden;
}


.tabbar {
  width: auto;
  height: 75px;
  z-index: 99;
  position: fixed;
  bottom: 8px;
  left: 10px;
  right: 10px;
  margin: auto;
  max-width: 430px;
  border-radius: 15px;
  background: rgba(255, 255, 255, 0.6);
  overflow: hidden;
  box-shadow: 0 0 15px 0 rgba(0, 8, 30, 0.15);
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
  will-change: backdrop-filter;

  // height: calc(100vh - 50px);
  // padding-bottom:50px;
  :deep(.van-tabbar-item__text) {
    margin-top: 5px;
  }

  :deep(.van-tabbar-item--active) {
    background-color: rgba(0, 0, 0, 0);
  }

  .imgTab {
    width: 26px !important;
    height: 26px !important;
  }

  :deep(.van-tabbar-item) {
    color: #000;
    font-size: 14px;
  }
}

.border {
  // padding-left: 30px;
  // padding-right: 30px;
}

// 语言弹窗
.popup {
  padding: 15px;
  width: 300px;

  .popup-title {
    font-family: Source Han Sans;
    font-size: 17px;
    font-weight: 700;
    line-height: normal;
    letter-spacing: 0;
    color: #000;
    margin-bottom: 15px;
  }

  .van-radio {
    display: flex;
    align-items: center;
    height: 35px;
    justify-content: space-between;
  }

  :deep(.van-radio__label) {
    color: #000;
    font-size: 14px;
  }
}
</style>
